<template>
  <div id="navigationbar">
    <nav
      class="navbar is-primary"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand" style="justify-content:space-between">
        <div class="navbar-item">
          <a href="/" class=""> <img :src="logourl" /> </a>
        </div>
      </div>
      <div class="navbar-menu">
        <div class="navbar-end">
          <div class="navbar-item">
            <a @click="isHelpModalActive = true" class="has-text-white">
              Ayuda &nbsp; &nbsp; &nbsp;
              <span class="icon is-small" style="margin-left:0.25em">
                <i class="mdi mdi-help-circle-outline has-text-white"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
      <!--  <div class="navbar-menu">
        <div class="navbar-end">
            <a href="#" class="navbar-item">  Sobre navandu.me &nbsp; <span class="icon is-small"> <i class="mdi mdi-help-circle-outline has-white-color" style="font-size:18px;"></i> </span> </a>
        </div>
      </div> -->
    </nav>
    <b-modal :active.sync="isHelpModalActive">
      <div class="container" style="padding:2em; max-width:768px">
        <p class="mb-4">
          Este producto utiliza el servicio de registro y acceso de Sngular
          People Europe, exclusivamente para profesionales de la salud
        </p>
        <p class="mb-4">
          Si ya utilizas otro producto de Sngular, sólo tienes que introducir tu
          nombre de usuario (dirección de correo electrónico) y contraseña para
          acceder. En otro caso es necesario que te registres y se requerirá
          validar tus datos profesionales.
        </p>
        <p class="mb-4">
          Si has recibido una invitación para utilizar este producto, introduce
          en el primer paso el código que te hayan comunicado.
        </p>
        <p class="mb-4">
          Para cualquier duda o consulta que te pueda surgir por favor dirígete
          a nosotros utilizando el acceso a nuestro Centro de Atención al
          Cliente, que encontrarás en el pie de página de la aplicación
        </p>
        <p class="mb-4">
          Si estás intentando registrarte y te dice que tu usuario ya existe, es
          posible que sea porque has creado una cuenta con anterioridad, prueba
          a <a v-on:click="modalGoToLink('login')"> acceder </a> o a
          <a v-on:click="modalGoToLink('resetpassword')">
            solicitar el cambio de contraseña </a
          >.
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'navigationBar',
  props: {
    webname: {
      type: String,
      default: ''
    }
  },
  methods: {
    modalGoToLink(mypath) {
      this.isHelpModalActive = false
      this.router.push({ path: mypath })
    }
  },
  data: () => ({
    isHelpModalActive: false
  }),
  computed: {
    logourl: function() {
      return process.env.BASE_URL + this.webname + '/logo_mobile.png'
    }
  }
}
</script>
<style lang="less">
#navigationbar .modal-content {
  background-color: white;
  padding: 1em;
}
</style>
